export class UpdateCarUserTokenActivationEntity {
    tokenId;
    isActive;

    constructor(tokenId, isActive) {
        this.tokenId = tokenId;
        this.isActive = isActive;
    }
}